// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  flagId: __t.u64().primaryKey().name("flag_id"),
  sessionId: __t.u64().name("session_id"),
  player: __t.identity(),
  kind: __t.string(),
  confidence: __t.f32(),
  action: __t.string(),
  detail: __t.string(),
  at: __t.timestamp(),
});
